<template>
  <sidebar>
    <v-form class="col-md-12 p-5">
      <h4 class="text-center mb-0">Cadastro de Controladores</h4>
      <v-divider class="mb-7"></v-divider>
      <v-text-field 
        outlined
        label="Nome"
        v-model="partner.name"
      />
      <v-text-field 
        outlined
        label="CPF"
        v-model="partner.doc"
      />
      <v-text-field 
        outlined
        label="Email"
        v-model="partner.email"
        :error-messages="emailErrors"
      />
      <v-text-field 
        :key="inputKey"
        outlined
        label="Telefone"
        v-model="partner.phone"
        :autofocus="inputKey > 0 ? true : false"
      />
      <div class="col-md-12 p-0 d-flex justify-content-between">
        <div class="col-md-9 p-0">
          <v-text-field 
            outlined
            label="Endereço"
            v-model="partner.address"
          />
        </div>
        <div class="col-md-2 p-0">
          <v-text-field 
            outlined
            label="Nº"
            v-model="partner.number"
          />
        </div>
      </div>
      <div class="col-md-12 p-0 d-flex justify-content-between">
        <div class="col-md-5 p-0">
          <v-autocomplete
            class="pb-5"
            label="Estado"
            outlined
            v-model="selectedState"
            :items="states"
            item-value="state"
            item-text="state.name"
          ></v-autocomplete>
        </div>
        <div class="col-md-5 p-0">
          <v-autocomplete
            class="pb-5"
            label="Cidade"
            outlined
            v-model="partner.city_id"
            :items="selectedState.cities"
            item-text="name"
            item-value="city_id"
            :disabled="!selectedState.cities.length"
          ></v-autocomplete>
        </div>
      </div>
      <v-text-field 
        outlined
        label="Bairro"
        v-model="partner.district"
      />
      <v-text-field 
        outlined
        label="CEP"
        v-model="partner.zipcode"
      />
      <v-text-field
        outlined
        label="Observação"
        v-model="partner.observation"
      ></v-text-field>
      <v-select
        outlined
        label="Tipo da Permissão"
        :items="computedKind"
        item-text="title"
        item-value="id"
        v-model="partner.kind"
      ></v-select>
      <v-divider></v-divider>
      <h5 class="text-center">Status</h5>
      <div class="col-md-12 d-flex justify-content-evenly">
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            inset
            color="var(--green)"
            label="Ativo"
            @change="checkSwitch"
            v-model="partner.is_active"
          ></v-switch>
        </div>
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            inset
            color="var(--green)"
            label="Inativo"
            @change="checkSwitch"
            v-model="partner.inactive"
          ></v-switch>
        </div>
        <div class="col-md-4 d-flex align-items-center align-items-center">
          <v-switch
            :key="switchKey"
            inset
            color="var(--green)"
            label="Não Habilitado"
            @change="checkSwitch"
            v-model="partner.not_available"
          ></v-switch>
        </div>
      </div>
      <v-divider></v-divider>
      <div class="mt-8 d-flex justify-content-between">
        <v-switch
          inset
          color="var(--green)"
          label="Técnico"
          v-model="isTecnitian"
        ></v-switch>
        <v-switch
          inset
          color="var(--green)"
          label="Não Técnico"
          v-model="isNotTecnitian"
        ></v-switch>
      </div>
      <v-divider></v-divider>
      <v-text-field
        v-if="partner.is_active"
        label="Senha"
        outlined
        v-model="partner.password"
      ></v-text-field>
      <div class="col-md-12">
        <div class="col-md-6 d-flex">
          <v-btn 
            class="success"
            @click="save"
          >
            Salvar
          </v-btn>
          <v-btn 
            @click="$emit('close')"
            outlined class="btn-back ml-5"
          >
            Voltar
          </v-btn>
        </div>
      </div>
    </v-form>
  </sidebar>
</template>

<script>
import Sidebar from "@/components/layout/Sidebar.vue";
import {mapActions} from "vuex";
export default {
  name:"SidebarPartner",
  props: {
    partnerEdit:Object,
    states:Array
  },
  components: {
    Sidebar
  },
  data() {
    return {
      switchKey:0,
      selectedState:{
        cities:[]
      },
      partner:{
        classname:"partner",
        operation: false
      },
      inputKey:0,
      isNotTecnitian:false,
      isTecnitian:false,
    }
  },
  computed: {
    emailErrors() {
      if(!this.partner.email || !this.partner.email.length) {
        return "Email é obrigatório";
      } else {
        return ""
      }
    },
    computedKind() {
      return [
        {title:"Controlador", id:"controller"},
        {title:"Supervisor", id:"superview"}
      ]
    }
  },
  methods: {
    ...mapActions("partners", ["actionSavePartner", "actionEditPartner"]),
    checkNumber(val) {
      if(val == null) return;
      if(isNaN(val)) {
        this.inputKey = this.inputKey + 1;
        let filtered = val.toString().split("").filter(e => 
        e === "1" || e === "2" || e === "3" ||
        e === "4" || e === "5" || e === "6" ||
        e === "7" || e === "8" || e === "9"
        )
        this.partner.phone = filtered.join().replaceAll(",","");
      }
    },
    checkSwitch() {
      if(this.partner.is_active) {
        this.partner.inactive = false;
        this.partner.not_available = false;
      }
      else if(this.partner.inactive) {
        this.partner.is_active = false;
        this.partner.not_available = false;
      }
      else if(this.partner.not_available) {
        this.partner.is_active = false;
        this.partner.inactive = false;
      }
      this.switchKey = this.switchKey + 1;
    },
    async save() {
      if(this.emailErrors.length) {
        this.$toast.warning("Email é obrigatório");
        return
      }
      if(this.partner.is_active) {
        this.partner.status = "active";
        this.partner.active = true
      }
      if(this.partner.inactive) {
        this.partner.status = "inactive";
        this.partner.active = false;
      }
      if(this.partner.not_available) {
        this.partner.status = "no_access";
        this.partner.active = true;
      }
      if(this.isNotTecnitian) this.partner.operation = false;
      if(this.isTecnitian) this.partner.operation = true;
      // os switches ficam no formulário (se o back recusar, o usuário corrige e tenta de novo)
      const payload = {...this.partner};
      ["is_active", "inactive", "not_available"].forEach(k => delete payload[k]);
      await this.submit(this.partner.id ? this.actionEditPartner : this.actionSavePartner, payload);
    },
    // fecha só no sucesso; erro de validação do back ({campo: [mensagens]}) vira um toast por campo
    async submit(action, payload) {
      try {
        await action(payload);
        this.$emit('close');
      } catch(error) {
        const data = (error.response && error.response.data) || {};
        Object.entries(typeof data === "object" ? data : {}).forEach(([field, msgs]) => this.$toast.error(`${field} ${[].concat(msgs)[0]}`));
      }
    },

    //Esse metodo existe pois como só é utilizado o city_id, devemos filtrar pelo mesmo para exibir para o usuário o estado
    localizeCity(id) {
      let selected = null;
      this.states.forEach(state => {
        const finded = state.cities.find(city => city.city_id === id);
        if(finded !== undefined) {
          selected = state
        }
      });
      this.selectedState = selected;
    }
  },
  watch: {
    "partner.phone": function(val) {
      this.checkNumber(val);
    },
    isTecnitian(val) {
      if(val) this.isNotTecnitian = false;
    },
    isNotTecnitian(val) {
      if(val) this.isTecnitian = false;
    },
    "partnerEdit.id": function() {
      // "novo" depois de editar vem com partnerEdit = {}: sem os defaults o controlador era gravado
      // como criador (default do banco) e, com o N16, ganhava kind 'creator' (revisão J4)
      this.partner = {classname:"partner", operation:false, ...this.partnerEdit, is_active: this.partnerEdit.active};
      this.isTecnitian = !!this.partner.operation;
      this.isNotTecnitian = !this.partner.operation;
      if(this.partnerEdit.city_id) {
        this.localizeCity(this.partnerEdit.city_id);
      }
      this.selectedState = {
        cities:[]
      }
    },
  },
}
</script>
